// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".-VoOM {\n    margin: var(--s) 0 var(--s) var(--s);\n    display: flex;\n    justify-content: flex-end;\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SheetController_sheetController": "-VoOM"
};
export default ___CSS_LOADER_EXPORT___;
